import React from "react";
const NoFound = () => {
  return <div>página no existe</div>;
};

export default NoFound;
